if (!customElements.get('cart-upsell-slider')) {
  customElements.define(
    'cart-upsell-slider',
    class CartUpsellSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cart-upsell__track');
        this.previousButton = this.querySelector('[data-cart-upsell-prev]');
        this.nextButton = this.querySelector('[data-cart-upsell-next]');

        if (!this.track) return;

        this.previousButton?.addEventListener('click', () => this.scrollByDirection(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByDirection(1));
      }

      scrollByDirection(direction) {
        const slide = this.track.querySelector('.cart-upsell__slide');
        if (!slide) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
        const distance = slide.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }
    }
  );
}
